// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__RB9b3","title":"Timer_title__3c--F","time":"Timer_time__3NF9h"};